<div [formGroup]="tourFormGroup" class="form flex flex-col">

  <nx-edit-select-input
    formControlName="resource"
    [label]="'tourPlanningModule.tourSettingsDialogComponent.form.vehicle.label' | translate"
    [showClear]="true"
    [filter]="true"
    [options]="tour?.transportCandidates">
  </nx-edit-select-input>
  <nx-edit-select-input
    formControlName="assignee"
    [label]="'tourPlanningModule.tourSettingsDialogComponent.form.driver.label' | translate"
    [showClear]="true"
    [filter]="true"
    [options]="drivers">
  </nx-edit-select-input>
  <nx-textfield-input
    formControlName="description"
    [placeholder]="'tourPlanningModule.tourSettingsDialogComponent.form.tourNote.placeholder' | translate"
    [label]="'tourPlanningModule.tourSettingsDialogComponent.form.tourNote.label' | translate"
    [rows]="3"/>
  <div class="p-field">
    <label for="range">{{ 'tourPlanningModule.tourSettingsDialogComponent.form.startTime.label' | translate }}</label><br/>
    <!-- {{useNewDateTimeControls}} -->
    <ng-container *ngIf="useNewDateTimeControls; else legacyStartDate">
      <nx-anchor-datetime-input
        [anchorDate]="anchorDate"
        formControlName="startDateControl">
      </nx-anchor-datetime-input>
    </ng-container>
    <ng-template #legacyStartDate>
      <p-calendar
        [style]="{'width':'100%'}"
        formControlName="startDateControl"
        id="fromDate"
        dateFormat="dd.mm.yy"
        [showTime]="true"
        hourFormat="24"
        [placeholder]="'tourPlanningModule.tourSettingsDialogComponent.form.startTime.placeholder' | translate"
        appendTo="body"
        [showClear]="true"
        [ngClass]="{'error-border':  dateRangeInvalid}">
      </p-calendar>
    </ng-template>
  </div>
  <div class="p-field">
    <label for="range">{{ 'tourPlanningModule.tourSettingsDialogComponent.form.endTime.label' | translate }}</label><br/>
    <ng-container *ngIf="useNewDateTimeControls; else legacyEndDate">
      <nx-anchor-datetime-input
        [anchorDate]="endAnchorDate"
        [minDate]="startDateValue"
        formControlName="endDateControl">
      </nx-anchor-datetime-input>
    </ng-container>
    <ng-template #legacyEndDate>
      <p-calendar
        [style]="{'width':'100%'}"
        formControlName="endDateControl"
        id="toDate"
        dateFormat="dd.mm.yy"
        [showTime]="true"
        hourFormat="24"
        [placeholder]="'tourPlanningModule.tourSettingsDialogComponent.form.endTime.placeholder' | translate"
        appendTo="body"
        [showClear]="true"
        [ngClass]="{'error-border': dateRangeInvalid}">
      </p-calendar>
    </ng-template>
  </div>
  <nx-edit-select-input
  formControlName="departureAddress"
  [label]="'tourPlanningModule.tourSettingsDialogComponent.form.departureLocation.label' | translate"
  [showClear]="true"
  [options]="departureAddresses">
</nx-edit-select-input>
<nx-edit-select-input
  formControlName="arrivalAddress"
  [label]="'tourPlanningModule.tourSettingsDialogComponent.form.arrivalLocation.label' | translate"
  [showClear]="true"
  [options]="arrivalAddresses">
</nx-edit-select-input>


<div>
